import BaseService from './BaseService'
import config from './../config/index'

class WhatsAppService extends BaseService {
  constructor(baseUrl: string) {
    super(baseUrl)
  }

  isConfigured = (locationId: string) =>
    this.requests.get(
      `/location/${locationId}/is-configured`
    )
  companyHasWallet = (companyId: string) =>
    this.requests.get(
      `/company/${companyId}/has-wallet`
    )
  resync = (data: {locationId: string}) =>
    this.requests.put(
      `/location/${data.locationId}/resync`,
      {}
    )
  delete = (data: {locationId: string}) =>
    this.requests.delete(
      `/location/${data.locationId}/delete`,
      {}
    )
  disconnect = (data: {locationId: string}) =>
    this.requests.delete(
      `/location/${data.locationId}/disconnect`,
      {}
    )
  getAccountInfo = (data: {locationId: string}) =>
    this.requests.get(
      `/location/${data.locationId}/account-info`,
      {}
    )
  getWhatsAppPhoneNumbersForLocationId = (locationId: string) =>
    this.requests.get(
      `/location/${locationId}/phone-numbers`
    )
  makeDefaultPhoneNumber = (locationId: string, phoneNumberId: string) =>
    this.requests.put(
      `/location/${locationId}/phone-numbers/${phoneNumberId}/default`,
      {}
    )
  getWhatsAppTemplatesForLocationId = (locationId: string, templateId: string, includeRewriterIds: boolean) =>{
    let url = `/location/${locationId}/template`

    if (templateId) {
      url += `?templateId=${templateId}`
    }
    if (includeRewriterIds) {
      url += '?includeRewriterIds=true'
    }

    return this.requests.get(
      url
    )
  }
  createWhatsAppTemplateForLocationId = (locationId: string, data: any) =>
    this.requests.post(
      `/location/${locationId}/template`,
      data
    )
  updateWhatsAppTemplateForLocationId = (locationId: string, templateId: string, data: any) =>
    this.requests.put(
      `/location/${locationId}/template/${templateId}`,
      data
    )
  deleteWhatsAppTemplateForLocationId = (locationId: string, templateId: string, templateName: string) =>
    this.requests.delete(
      `/location/${locationId}/template/${templateId}/${templateName}`,
    )
  getTemplateFolders = (locationId: string, folderId?: string) => {
    const url = folderId ? `/location/${locationId}/folders?folderId=${folderId}` : `/location/${locationId}/folders`
    const res = this.requests.get(
      url
    )
    return res
  }
  createTemplateFolder = (locationId: string, data: any) =>
    this.requests.post(
      `/location/${locationId}/folders`,
      data
    )
  updateTemplateFolder = (locationId: string, data: any) => {
    if(data.folderId){
      const url = `/location/${locationId}/folders/${data.folderId}`
      delete data.folderId
      return this.requests.put(
        url,
        data
      )
    } else {
      console.log('data.folderId is not present')
    }
  }
  deleteTemplateFolder = (locationId: string, folderId: string, parentFolderId?: string) => {
    try {
      const deletionResponse  = this.requests.delete(
        `/location/${locationId}/folders/${folderId}?parentFolderId=${parentFolderId}`,
      )
      return deletionResponse
    } catch (error) {
      return error
    }
  }
  addTemplateToFolder = (locationId: string, data: any) => {
    return this.requests.post(
      `/location/${locationId}/folders/map-template`,
      data
    )
  }
  getProduct = () =>
    this.requests.get(
      '/reselling/product',
    )
  getCompanyResellingConfiguration = (companyId: string) =>
    this.requests.get(
      `/company/${companyId}/reselling/configuration`
    )
  updateCompanyResellingConfiguration = (companyId: string, data: { amount: number }) =>
    this.requests.put(
      `/company/${companyId}/reselling/configuration`,
      data
    )
  getLocationResellingConfiguration = (locationId: string) =>
    this.requests.get(
      `/location/${locationId}/reselling/configuration`
    )
  updateLocationResellingConfiguration = (locationId: string, data: { amount?: number, offeringEnabled?: boolean }) =>
    this.requests.put(
      `/location/${locationId}/reselling/configuration`,
      data
    )
  getCompanySubscriptions = (companyId: string) =>
    this.requests.get(
      `/company/${companyId}/reselling/subscription`
    )
  getLocationSubscriptions = (locationId: string) =>
    this.requests.get(
      `/location/${locationId}/reselling/subscription`
    )
  canHaveTrail = (locationId: string) =>
    this.requests.get(
      `/location/${locationId}/reselling/subscription/can-have-trail`
    )

  cancelSubscription = (locationId: string, reason: string) => {
      this.requests.delete(`/location/${locationId}/cancelSubscription`, {}, {
      reason
    })
  }

  locationSub = (locationId: string, data) =>
    this.requests.post(
      `/location/${locationId}/reselling/subscription`,
      data
    )
  getMediaUrlInfo = (url: string) =>
    this.requests.get(`/media?url=${url}`)
  getAttachement = (locationId: string, messageId: string) =>
    this.requests.get(
      `/location/${locationId}/messages/${messageId}/attachment`, {
        responseType: 'blob'
      }
    )
  postAttachement = (locationId: string, conversationId: string, data) =>
    this.requests.post(
      `/location/${locationId}/attachment?conversationId=${conversationId}`, data
    )
  voiceNote = (params, data) =>
    this.requests.post(
      `/location/${params.locationId}/voice-note?userId=${params.userId}&contactId=${params.contactId}&conversationId=${params.conversationId}`, data
    )
  upload = (locationId: string, data) =>{
    let url = `/location/${locationId}/uploads`
    return this.requests.post(
      url, data.formData
    )
  }
  getSignedUrl = (locationId: string, data) => {
    let url = `/location/${locationId}/media-signed-url`
    return this.requests.post( url, data )
  }
  enableWhatsAppConversationRebilling = (companyId: string, locationId: string) =>
    this.requests.post(
      `/company/${companyId}/location/${locationId}/rebilling/enable`,
      {}
    )
  getWhatsappBusinessProfileData = (phoneNumberId: string, wabaId: string) =>
    this.requests.get(
      `/businessprofile/${wabaId}/${phoneNumberId}`
    )
  postWhatsappBusinessProfileData = (data) => {
      const phoneNumberId = data.phoneNumberId
      const wabaId = data.wabaId

      delete data.wabaId
      delete data.phoneNumberId
      return this.requests.post(
        `/businessprofile/${wabaId}/${phoneNumberId}`,
        data
      )}
  addPhoneNumber = (locationId: string, data) => {
    return this.requests.post(
      `/phone-numbers?locationId=${locationId}`,
      data
    )
  }
  sendOtp = (data) => {
    return this.requests.post(
      `/phone-numbers/send-otp`,
      data
  )}
  verifyOtp = (data) => {
    return this.requests.post(
      `/phone-numbers/verify-otp`,
      data
  )}
  getAnalytics = (data) => {
    const templateIdsParam = data.templateIds.map(id => `templateIds[]=${id}`).join('&')
    const url = `/analytics?startDate=${data.startDate}&endDate=${data.endDate}&wabaId=${data.wabaId}&${templateIdsParam}`
    return this.requests.get(url)
  }

  register = (data) => {
    return this.requests.post(
      `/phone-numbers/register`,
      data
  )}
  getFlows = (locationId) => {
    return this.requests.get(
      `/flows?locationId=${locationId}`,
    )
  }
  createFlowToken = (data) => {
    return this.requests.post(
      `/flows/token`,
      data
    )
  }
  createFlow = (data) => {
    return this.requests.post(
      `/flows?whatsAppBusinessAccountId=${data.wabaId}`, data.body
    )
  }
  updateFlow = (data) => {
    return this.requests.put(
      `/flows/${data.flowId}?locationId=${data.locationId}&whatsAppBusinessAccountId=${data.wabaId}`, data.body
    )
  }
  updateFlowAssets = (data) => {
    return this.requests.put(
      `/flows/${data.flowId}/assets`, data.body
    )
  }
  flowPreview = (data) => {
    return this.requests.get(
      `/flows/${data.flowId}/preview`
    )
  }
  flowPublish = (data) => {
    return this.requests.post(
      `/flows/${data.flowId}/publish?locationId=${data.locationId}&whatsAppBusinessAccountId=${data.wabaId}`, {}
    )
  }
  deprecateFlow = (data) => {
    return this.requests.post(
      `/flows/${data.id}/deprecate?locationId=${data.locationId}&whatsAppBusinessAccountId=${data.wabaId}`, {}
    )
  }
  deleteFlow = (data) => {
    return this.requests.delete(
      `/flows/${data.id}/delete?locationId=${data.locationId}&whatsAppBusinessAccountId=${data.wabaId}`, {}
    )
  }

  getOnboardingChecklist = (locationId: string) => {
    return this.requests.get(
      `/onboarding-checklist/${locationId}`
    )
  }

  templateRewriter = (data) => {
    return this.requests.put(
      `/ai/template-rewriter`, data
    )
  }
}

export const whatsAppService = new WhatsAppService(config.ghlRevexBackendUrl + '/whatsapp')

export default {}